import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const MyContests: React.FC = () => {


    return (
        <div className="MyContests">
            <h1>My Contests</h1>
            <p>This is the My Contests page.</p>
            <p>Here you can view and manage your contests.</p>
            <p>More features will be added soon!</p>
            <p>Stay tuned!</p>
        </div>
    )
}

export default MyContests;